import { FormControlLabel, Radio } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormError } from './hook-form-error';

interface RadioButtonGroupFieldProps {
  valueKey: string;
  labelKey: string;
  name: string;
  optionData: any[];
  disable?: boolean;
  onValueChange?: (value: any) => void;
}

interface RadioButtonProps {
  groupName: string;
  valueKey: string;
  labelKey: string;
  optionData: any[];
  onChange: any;
  value: any;
  disable?: boolean;
}

const RadioButtonGroup = ({
  labelKey,
  valueKey,
  optionData,
  onChange,
  groupName,
  value,
  disable,
}: RadioButtonProps) => {
  const handleChange = (e: any) => {
    const {
      target: { checked, value: itemValue },
    } = e;

    if (checked) {
      onChange(itemValue);
    } else {
      onChange(undefined);
    }
  };

  return (
    <>
      {optionData.map((d: any) => {
        return (
          <FormControlLabel
            key={d[valueKey]}
            control={
              <Radio
                size='small'
                radioGroup={groupName}
                onChange={handleChange}
                value={d[valueKey]}
                checked={value?.toString() === d[valueKey].toString()}
                disabled={disable}
              />
            }
            label={d[labelKey]}
          />
        );
      })}
    </>
  );
};

export const FormRadioButtonGroup = ({
  valueKey,
  labelKey,
  name,
  optionData,
  onValueChange,
  disable,
}: RadioButtonGroupFieldProps): any => {
  const { control } = useFormContext();

  return (
    <div>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <RadioButtonGroup
              optionData={optionData}
              onChange={(e: any) => {
                onChange(e);
                onValueChange?.(e);
              }}
              labelKey={labelKey}
              valueKey={valueKey}
              groupName={name}
              value={value}
              disable={disable}
            />
          );
        }}
      />
      <FormError name={name} />
    </div>
  );
};
